<app-loader />
<div class="layout-wrapper" [ngClass]="containerClass()">
  <app-header />
  <app-sidebar />
  <div class="layout-main-container">
    <div class="layout-main">
      <router-outlet />
    </div>
    <app-footer />
  </div>
  <div class="layout-mask" (click)="layoutService.closeMobileMenu()"></div>
</div>

<!-- The gear in the top bar opens this: mode, direction and the theme's primary colour. -->
<app-theme-settings />

<!-- Sign-out warning (SessionTimeoutService): the last minute before an idle sign-out, or before the sign-in session
     itself ends. Extend session starts the idle clock over; with no answer the user is signed out when the countdown
     ends and the login page says why. Same design as the tenant portal's. -->
@if (sessionTimeoutService.showWarning()) {
  <div class="idle-dialog" role="alertdialog" aria-modal="true" aria-labelledby="idle-title" aria-describedby="idle-message">
    <div class="idle-dialog__card">
      <header class="idle-dialog__header">
        <span class="idle-dialog__icon" aria-hidden="true"><i class="ri-timer-line"></i></span>
        <div>
          <h5 id="idle-title" class="idle-dialog__title">Session expiring soon</h5>
          <p class="idle-dialog__subtitle">
            @if (sessionTimeoutService.sessionEnding()) {
              Your sign-in session is about to end.
            } @else {
              You've been inactive for {{ sessionTimeoutService.idleMinutes }} {{ sessionTimeoutService.idleMinutes === 1 ? 'minute' : 'minutes' }}.
            }
          </p>
        </div>
      </header>

      <div class="idle-dialog__timer" [class.idle-dialog__timer--urgent]="countdownUrgent()">
        <svg viewBox="0 0 100 100" aria-hidden="true">
          <circle class="idle-dialog__ring-track" cx="50" cy="50" r="42" />
          <circle class="idle-dialog__ring" cx="50" cy="50" r="42"
            [attr.stroke-dasharray]="ringLength" [attr.stroke-dashoffset]="ringOffset()" />
        </svg>
        <div class="idle-dialog__time" aria-live="polite" aria-atomic="true">
          <span class="idle-dialog__time-value">{{ countdown() }}</span>
          <span class="idle-dialog__time-label">remaining</span>
        </div>
      </div>

      @if (sessionTimeoutService.sessionEnding()) {
        <p id="idle-message" class="idle-dialog__message">
          For your security, sign-in sessions have a fixed length. Save your work; you will need to sign in again.
        </p>
        <footer class="idle-dialog__actions idle-dialog__actions--single">
          <button type="button" class="idle-dialog__btn idle-dialog__btn--primary" (click)="sessionTimeoutService.logoutNow()" autofocus>
            Sign in again
          </button>
        </footer>
      } @else {
        <p id="idle-message" class="idle-dialog__message">
          For your security, you will be signed out automatically. Select <strong>Extend session</strong> to continue working.
        </p>
        <footer class="idle-dialog__actions">
          <button type="button" class="idle-dialog__btn idle-dialog__btn--secondary" (click)="sessionTimeoutService.logoutNow()">
            Sign out
          </button>
          <button type="button" class="idle-dialog__btn idle-dialog__btn--primary" (click)="sessionTimeoutService.extendSession()" autofocus>
            Extend session
          </button>
        </footer>
      }
    </div>
  </div>
}